// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
} from '@mui/material';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';
import { useDeleteDeviceDataMutation, useGetAllDeviceDataMutation } from '../../store/api/posDeviceApi';
import { getPosDevice, getPosDeviceTotalRecord, setPosDevide } from '../../store/state/posDeviceSlice';
import toast from 'react-hot-toast';


const TABLE_HEAD = [
  { id: 'device id', label: 'Device Id', alignRight: false },
  { id: 'device name', label: 'Device Name', alignRight: false },
  { id: 'parking name', label: 'Parking Name', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
];

export default function PosDevice() {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const [posManagementData, setPosManagementData] = useState([]);
  const [getAllDeviceData, getAllDeviceDataResponse] = useGetAllDeviceDataMutation();
  const posData = useAppSelector(getPosDevice);
  const posTotalRecord = useAppSelector(getPosDeviceTotalRecord);
  const [deleteDeviceData, deleteDeviceDataResponse] = useDeleteDeviceDataMutation();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [vendorId, setVendorId] = useState<number>();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const filteredUsers = posManagementData;
  const isUserNotFound = filteredUsers.length === 0;
  

  useEffect(() => {
    if (posData) {
      setPosManagementData(posData);
    }
  }, [posData]);

  useEffect(() => {
    getAllDeviceData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        status:true,
      },
    });
    setFilterName('')
  }, []);

  useEffect(() => {
    if (getAllDeviceDataResponse.isSuccess) {
      dispatch(setPosDevide(getAllDeviceDataResponse.data));
    }
    if (getAllDeviceDataResponse.isError) {
      let errorData: any = getAllDeviceDataResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllDeviceDataResponse.isSuccess, getAllDeviceDataResponse.isError]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  useEffect(() => {
    if (deleteDeviceDataResponse.isSuccess) {
      getAllDeviceData({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          orderBy: order,
        },
      });
      toast.success('Pos device updated successfully.');

    }
    if (deleteDeviceDataResponse.isError) {
      let errorData: any = deleteDeviceDataResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [deleteDeviceDataResponse.isSuccess, deleteDeviceDataResponse.isError]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllDeviceData({ token: token.token, payload: { offset: rowsPerPage, page: newPage } });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllDeviceData({ token: token.token, payload: { offset: parseInt(event.target.value, 10), page: 0 } });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
      getAllDeviceData({
        token: token.token,
        payload: { offset: rowsPerPage, page: page, searchValue: event.target.value },
      });
  };

  const handleDelete = () => {
    setOpen(false);
    deleteDeviceData({
      id: vendorId,
      token: token.token,
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };
 

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  return (
    <Page title="Pos Device">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
            <Typography variant="h4" gutterBottom>
              Pos Device
            </Typography>
            <Button
              style={{ color: 'white', backgroundColor: '#E23744' }}
              variant="contained"
              onClick={() => {
                navigate('/dashboard/add-or-update-pos-device', { state: { editMode: false } });
              }}
              startIcon={<Iconify icon="eva:plus-fill" />}
              size="large"
            >
              Add
            </Button>
          </Stack>
          <Card>
            <BookingListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              placeholder={'Search By Device Id'}
            />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <AllParkingsListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={posManagementData.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.length > 0 &&
                      filteredUsers.map((row) => {
                        const { id,  status  , deviceId, name ,parkingName} = row;
                        const isItemSelected = selected.indexOf(name) !== -1;

                        return (
                          <TableRow
                            hover
                            key={id.toString()}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            <TableCell
                              align="left"
                              onClick={() => {
                                navigate('/dashboard/add-or-update-pos-device', { state: { editMode: true, editData: row } });
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <Typography fontWeight="normal" variant="subtitle2" color={'blue'}>
                                {deviceId}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="normal" variant="subtitle2">
                                {name}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="normal" variant="subtitle2">
                                {parkingName}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Stack direction="row" alignItems="center">
                                <Switch
                                  checked={status}
                                  onClick={() => {
                                    setVendorId(id);
                                    handleOpen();
                                  }}
                                />
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>

                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={posTotalRecord || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
          {open && (
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                  Are you sure?
                </Typography>
                <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                  <Button
                    variant="contained"
                    onClick={cancelDelete}
                    sx={{ margin: '10px' }}
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleDelete}
                    sx={{ margin: '10px' }}
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                  >
                    Yes
                  </Button>
                </Stack>
              </Box>
            </Modal>
          )}

          {getAllDeviceDataResponse.isLoading ? <Loading /> : null}
        </Container>
    </Page>
  );
}
